import React, { Component } from "react";
import { Link, NavLink }	from "react-router-dom";
import PerfectScrollbar		from "react-perfect-scrollbar";
import {dashboardMenu}		from "../data/Menu";
import atlasApi				from "../utils/atlasapi";


export default class Sidebar extends Component {
		
	constructor(props) {
		super(props);
		
		this.state = {
			settings: {open:false},
			
		}
		
	}
		
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    };
	
	
    render() {
		
        return (
            <div className="sidebar" onClick={this.props.onClick}>
				{this.props.prepend}
                <PerfectScrollbar className="sidebar-body" ref={ref => this._scrollBarRef = ref}>
					{!this.props.hideMenu ? (<SidebarMenu onUpdateSize={() => this._scrollBarRef.updateScroll()} />) : ''}
                    {this.props.add}
					{this.props.children}
                </PerfectScrollbar>
				
				
					
					
            </div>
        )
    }
}

class SidebarMenu extends Component {
    populateMenu = (m) => {
		
		
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink to={sm.link} className="nav-sub-link" key={key}>{sm.label}</NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink to={m.link} className={"nav-link " + (!key && window.location.pathname=="/" ? 'active' : '')} >{m.icon} <span>{m.label}</span></NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub">{m.icon} <span>{m.label}</span></div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    // Toggle menu group
    toggleMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    // Toggle submenu while closing siblings' submenu
    toggleSubMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    render() {
        return (
            <React.Fragment>
                <div className="nav-group mainmenu show  mb-3">
                    
                    {this.populateMenu(dashboardMenu)}
                </div>

            </React.Fragment>
        )
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-profile") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body").classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});